// @ts-nocheck
import {
  ConsentActions,
  ConsentStates,
  ConsolidatedConsentCategories,
} from '../constants/consent';
import Events from '../constants/events';
import store from '../store';
import { siteApi } from '../services';
import { handleError, setCookie } from '../utilities';

const processConsentEvents = async (consentEvents) => {
  const privacyConsents =
    consentEvents.filter((rec) => rec.category === 'privacy_setting') || [];
  let allowState = {};
  if (privacyConsents.length > 0) {
    allowState = privacyConsents.reduce(
      (a, { subcategory, consentState: state }) => ({
        ...a,
        [subcategory]: state === 'accepted',
      }),
      {},
    );
  }

  const result = {
    success: false,
  };

  try {
    await siteApi
      .postConsentEvents({
        items: consentEvents,
      })
      .then(() =>
        setCookie({
          name: `concord-allow-state-${store.consentState.regionId}`,
          value: JSON.stringify({
            ...store.consentState.allowState,
            ...allowState,
          }),
          maxAge: store.consentState.regionExpiration,
        }),
      )
      .then(() => {
        return store.consentState.refreshData({ forceRefresh: true });
      });
    result.success = true;
  } catch (err) {
    handleError(err);
    result.error = err;
  }
  return result;
};

export default new Proxy(
  {
    addConsentEvent: async (details) => {
      return await processConsentEvents([details]);
    },

    addConsentEvents: async (consentEvents) => {
      return await processConsentEvents(consentEvents);
    },

    findConsentState: ({
      consentTypeId,
      category,
      subcategory,
      label,
      version,
    }) => {
      try {
        let {
          consentState: { consentState: state },
        } = store;
        if (consentTypeId) {
          state = state.filter((e) => e?.consentType?.id === consentTypeId);
        }
        if (category) {
          state = state.filter((e) => e?.consentType?.category === category);
        }
        if (subcategory) {
          state = state.filter(
            (e) => e?.consentType?.subcategory === subcategory,
          );
        }
        if (label) {
          state = state.filter((e) => e?.consentType?.label === label);
        }
        if (version) {
          state = state.filter((e) => e?.version === version);
        }
        return state;
      } catch (err) {
        handleError(err);
      }
      return [];
    },
    findConsentTypes: ({
      consentTypeId,
      category,
      subcategory,
      label,
      version,
    }) => {
      try {
        let { consentTypes: types } = store;
        if (consentTypeId) {
          types = types.filter((e) => e.id === consentTypeId);
        }
        if (category) {
          types = types.filter((e) => e.category === category);
        }
        if (subcategory) {
          types = types.filter((e) => e.subcategory === subcategory);
        }
        if (label) {
          types = types.filter((e) => e.label === label);
        }
        if (version) {
          types = types.filter((e) => e.version === version);
        }
        return types;
      } catch (err) {
        handleError(err);
      }
      return [];
    },
    states: ConsentStates,
    actions: ConsentActions,
    categories: ConsolidatedConsentCategories,

    events: Object.fromEntries(
      Object.entries(Events).filter(([, value]) =>
        value.startsWith('concord-consent'),
      ),
    ),
    onConsentStateChanged: (callback) =>
      window.addEventListener(Events.ConsentStateChanged, callback),
    onConsentStateLoaded: (callback) =>
      window.addEventListener(Events.ConsentStateLoaded, callback),
    onConsentStateLoading: (callback) =>
      window.addEventListener(Events.ConsentStateLoading, callback),
    onConsentTypesChanged: (callback) =>
      window.addEventListener(Events.ConsentTypesChanged, callback),
    onConsentTypesLoaded: (callback) =>
      window.addEventListener(Events.ConsentTypesLoaded, callback),
    onConsentTypesLoading: (callback) =>
      window.addEventListener(Events.ConsentTypesLoading, callback),
  },
  {
    get: (obj, prop) => {
      if (prop === 'allowState') {
        return store.consentTypes.allowState;
      }
      if (prop === 'consentState') {
        return store.consentState.consentState;
      }
      if (prop === 'consentTypes') {
        return store.consentTypes;
      }
      return Reflect.get(obj, prop);
    },
    set: () => false,
  },
);
